import React from 'react'
import { AppBar, Box, IconButton, Toolbar, useTheme } from '@mui/material'
import { Menu as MenuIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import medendoLogo from '../../../assets/medendo_logo.png'

import { collapsedDrawerWidth, drawerWidth } from '../../../pages/App'

export const AppToolbar: React.FC<{
    open: boolean
    isMobile: boolean
    onMenuClick: () => void
}> = (props) => {
    const theme = useTheme()
    const { t } = useTranslation()

    // On mobile the drawer is an overlay, so it takes no horizontal space.
    const drawerOffset = props.isMobile ? 0 : props.open ? drawerWidth : collapsedDrawerWidth

    return (
        <AppBar
            position="fixed"
            sx={{
                height: 64,
                width: `calc(100% - ${drawerOffset}px)`,
                ml: `${drawerOffset}px`,
                bgcolor: 'background.default',
                color: 'text.primary',
                boxShadow: 'none',
                borderBottom: '1px solid',
                borderColor: 'divider',
                borderRadius: 0,
                padding: 0,
                pt: props.isMobile ? 1 : 0,
                transition: theme.transitions.create(['margin', 'width'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            }}
        >
            <Toolbar
                sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {props.isMobile && (
                    <IconButton onClick={props.onMenuClick} aria-label={t('encounter.menu_open')}>
                        <MenuIcon />
                    </IconButton>
                )}
                <Box
                    sx={
                        props.isMobile
                            ? {
                                  position: 'absolute',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                              }
                            : undefined
                    }
                >
                    <img
                        src={medendoLogo}
                        alt=""
                        width={140}
                        style={props.isMobile ? undefined : { display: 'block' }}
                    />
                </Box>
            </Toolbar>
        </AppBar>
    )
}
